module.exports = "<router-outlet></router-outlet>\n<pre *ngIf=\"version\" style=\"position: fixed; left: 0; bottom: 0;\">{{version}}</pre>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main